module.exports = __webpack_public_path__ + "static/media/IconFolderActive.709d637d.svg";